import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { AppBar, Button, Dialog, DialogContent, DialogTitle, Divider, Grid, Icon, IconButton, Stack, TextField, Toolbar, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import AgGridTable from "../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import moment from "moment";

const LCTopUp = (props) => {
    const [openTopUp, setOpenTopUp] = useState(true);
    const [rowData, setRowData] = useState([]);
    const [topupData, setTopupData ] = useState({
        company:'',
        companyName: '',
        documentCreditNo:''
    })

    const handleDateFormat = (props) => {
        return props.value && moment(props.value).format('DD-MM-YYYY')
    }

    const renderCurrency = (props) => {
        return <span style={{ display: "flex" }}>
            <p>{new Intl.NumberFormat('en-US').format(props?.value)}</p>
        </span>;
    };

    const handleView = (params) => {
        props.handleAmmendView(params.data.id);
    }

    const handleEdit = (params) => {
        props.handleAmmendEdit(params.data.id);
    }

    const handleActions = (params) => {
        return params.data && <>
            <IconButton size="small" className="p-0" onClick={(e) => handleView(params)}><Icon fontSize="2rem">visibility</Icon></IconButton>
            <IconButton size="small" className="p-0" onClick={(e) => handleEdit(params)}><Icon>edit</Icon></IconButton>
        </>
    }

    const handleTotalAmount = (params) => {
        {new Intl.NumberFormat('en-US').format(props?.value)}
        return (params.data.dcAmount && params.data.toleranceAmount) && new Intl.NumberFormat('en-US').format(Number(params.data.dcAmount) + Number(params.data.toleranceAmount))
    }

    const [columnDefs, setColumnDefs] = useState([
        {field:'dateOfIssue', cellRenderer:handleDateFormat},
        {field:'dcAmount', headerName:'Top up Amount',cellRenderer: renderCurrency},
        {field:'toleranceAmount',cellRenderer: renderCurrency},
        {field:'totalAmount', cellRenderer: handleTotalAmount},
        {field:'action', headerName:'View / Edit', cellRenderer: handleActions},
    ]);
    const lcUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.letterOfCredit}`;

    const handleClose = () => {
        setOpenTopUp(false)
        props.handleClose()
    }

    const loadTopUpData = async() => {
        const list = await OAuthService.getList(lcUrl+`/topUp?letterOfCreditId=${props.lcId}`);
        if(list.data){
            setRowData(list.data)
            list.data.length > 0 && setTopupData({
                company: list.data[0].letterOfCredit.company,
                companyName: list.data[0].letterOfCredit.companyName,
                documentCreditNo: list.data[0].letterOfCredit.documentCreditNo
            })

        }
    }
    
    useEffect(() => {
        if(props.lcId){
            loadTopUpData()
        }
    }, [])

    return(
        <Dialog
        fullWidth={true}
        maxWidth={'md'}
            onClose={handleClose}
            open={openTopUp}
        >
            <AppBar position="static">
                <Toolbar className="flex w-full justify-between">
                    <Typography variant="subtitle1" color="inherit">
                    LC Top Up - Details
                    </Typography>
                    <Button onClick={handleClose}>
                        <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                    </Button>
                </Toolbar>
            </AppBar>
            <DialogContent dividers>
            <Grid container spacing={2} className="mt-8">
                <Grid item xs={8}>
                    <Stack>
                        <lable>Client Name</lable>
                        <TextField
                            value={topupData.companyName}
                            name="customer"
                            disabled
                            inputProps={{
                                sx: { 'padding': '10px' },
                            }}

                        />
                    </Stack>
                </Grid>
                <Grid item xs={4}>
                    <TextField
                        value={topupData.company}
                        name="customer"
                        disabled
                        inputProps={{
                            sx: { 'padding': '10px' },
                        }}
                        style={{ marginTop: "2rem" }}

                    />
                </Grid>
            </Grid>
            <Grid container className="mt-8" >
                <Grid item xs={12}>
                    <Stack>
                        <lable>Documentary Credit No</lable>
                        <TextField
                            value={topupData.documentCreditNo}
                            // name="customer"
                            disabled
                            inputProps={{
                                sx: { 'padding': '10px' },
                            }}

                        />
                    </Stack>
                </Grid>
            </Grid>
            <Divider />
            <div className="mt-8 h-[300px]" >
                <AgGridTable
                    rowData={rowData}
                    columnDefs={columnDefs}
                />
            </div>
            </DialogContent>
        </Dialog>
    )
}

export default LCTopUp